import React, { useEffect } from 'react'
import PageWrapper from 'Pages/@PageWrapper'
import { ADMIN_ROUTES } from '@constants'
import OfficeMappingFilters from 'Pages/Admin/OfficeMapping/Filters'
import { Grid } from '@mui/material'
import { AppFilterPanel } from '@components'
import OfficeMappingTable from 'Pages/Admin/OfficeMapping/Table'
import { clearSignals } from 'Pages/Admin/OfficeMapping/@signals'
import { offices, sites } from '@signals'

export default function OfficeMappingAdminPage() {

	useEffect(() => {
		offices.value = null
		sites.value = []
		clearSignals()
		return () => {
			offices.value = null
			sites.value = []
			clearSignals()
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.CUSTOM_OFFICE_SUBTITLE}
		isEmpty={false}
	>
		<AppFilterPanel>
			<OfficeMappingFilters/>
		</AppFilterPanel>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<OfficeMappingTable/>
			</Grid>
		</Grid>
	</PageWrapper>
}